var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.90779 6.48375C7.25932 6.83866 7.25942 7.41419 6.908 7.76923C5.9013 8.78629 5.2158 10.082 4.93818 11.4925C4.66055 12.903 4.80328 14.365 5.3483 15.6936C5.89332 17.0222 6.81616 18.1578 8.00014 18.9567C9.18412 19.7556 10.5761 20.1821 12 20.1821C13.4239 20.1821 14.8159 19.7556 15.9999 18.9567C17.1838 18.1578 18.1067 17.0222 18.6517 15.6936C19.1967 14.365 19.3394 12.903 19.0618 11.4925C18.7842 10.082 18.0987 8.78629 17.092 7.76923C16.7406 7.41419 16.7407 6.83866 17.0922 6.48375C17.4437 6.12883 18.0136 6.12892 18.365 6.48396C19.6234 7.75529 20.4803 9.37493 20.8273 11.1381C21.1743 12.9012 20.9959 14.7287 20.3146 16.3895C19.6334 18.0502 18.4798 19.4697 16.9998 20.4683C15.5198 21.467 13.7799 22 12 22C10.2201 22 8.48015 21.467 7.00018 20.4683C5.5202 19.4697 4.36664 18.0502 3.68537 16.3895C3.00409 14.7287 2.82569 12.9012 3.17272 11.1381C3.51975 9.37493 4.37663 7.75529 5.635 6.48396C5.98642 6.12892 6.55627 6.12883 6.90779 6.48375Z",
    fill: "#E71B4C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0045 2C12.5016 2 12.9045 2.40696 12.9045 2.90897V11.9987C12.9045 12.5007 12.5016 12.9076 12.0045 12.9076C11.5074 12.9076 11.1045 12.5007 11.1045 11.9987V2.90897C11.1045 2.40696 11.5074 2 12.0045 2Z",
    fill: "#E71B4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPower);
export default __webpack_public_path__ + "static/media/power.24a4b4a0668289e19f6b82be9fe58e88.svg";
export { ForwardRef as ReactComponent };